(function (angular) {
  "use strict";

  angular.module("Toyota.Directives").directive("tyPricingDriveaway", [
    "DebugLogger",
    function (DebugLogger) {
      function handleReject(error) {
        DebugLogger.log("tyPricingDriveaway", error);
      }

      var controller = [
        "$rootScope",
        "$scope",
        "$element",
        "PricingPageAnalyticsService",
        "cookies",
        "Dealer",
        "DealerSelector",
        "Tfy",
        function (
          $rootScope,
          $scope,
          $element,
          PricingPageAnalyticsService,
          cookies,
          dealer,
          DealerSelector,
          Tfy
        ) {
          $scope.pricingDriveaway = $scope.pricingDriveaway
            ? $scope.pricingDriveaway
            : {};
          $scope.driveawayPrice = $scope.driveawayPrice
            ? $scope.driveawayPrice
            : {};
          var pricingPageMaterialCodeEventTriggered = false;

          /**
           * There might be some other components (e.g. react component) that are listening to this event.
           * So, on first render, broadcast happens twice to make sure that every listener gets notified.
           */
          $scope.isFirstMaterialCodeBroadcast = true;
          $scope.broadcastMaterialCodeChange = function (code) {
            $rootScope.$broadcast(
              "pricing-page-material-code-paint-loaded-fire-thrice-first-time",
              code
            );

            if ($scope.isFirstMaterialCodeBroadcast) {
              $scope.isFirstMaterialCodeBroadcast = false;
              const firstBroadcastTimeout = 500,
                three = 3;

              setTimeout(function () {
                $scope.broadcastMaterialCodeChange(code);
              }, firstBroadcastTimeout);

              setTimeout(function () {
                $scope.broadcastMaterialCodeChange(code);
              }, three * firstBroadcastTimeout);
            }
          };

          $scope.$on(
            "saved-dealer-with-default-fallback-did-change",
            function () {
              var dealerObject = dealer.getSavedFallbackToDefault();

              Tfy.updateDealerInTfyCookie(
                dealerObject?.sapDealerCode,
                dealerObject?.branchCode
              );
            }
          );

          $scope.$on(
            "pricing-page-material-code",
            function (event, materialCodePromise) {
              materialCodePromise
                .then(function (pricingPageMaterialCodeObject) {
                  if (pricingPageMaterialCodeEventTriggered) {
                    Tfy.cacheMaterialCodeAndUpdateCookie(
                      Tfy.getCurrentPageVehicleModel()?.tfyModelName,
                      pricingPageMaterialCodeObject.materialCode
                    );
                  }
                  pricingPageMaterialCodeEventTriggered = true;

                  $scope.broadcastMaterialCodeChange(
                    pricingPageMaterialCodeObject.materialCode
                  );

                  $scope.driveawayPrice.materialCode =
                    pricingPageMaterialCodeObject.materialCode;
                  $scope.driveawayPrice
                    .fetchPriceAndRepaint()
                    .then(function () {
                      $scope.$broadcast(
                        "pricing-page-driveaway-price-loaded",
                        $scope.driveawayPrice.hasPrice
                      );
                    });
                })
                .catch(handleReject);
            }
          );

          $scope.$watch("driveawayPrice.price", function (value) {
            if (value) {
              PricingPageAnalyticsService.setDriveawayPrice(value);
            }
          });

          $scope.pricingDriveawayShowLocationModal = function (label) {
            DealerSelector.openDealerSelector();

            PricingPageAnalyticsService.triggerAnalytics("gaClick", {
              eventCategory: "pricing",
              eventAction: "link",
              eventLabel: label && label !== null ? label : "set location",
            });
          };
        },
      ];

      return {
        scope: false,
        restrict: "A",
        controller: controller,
        bindToController: true,
        controllerAs: "pricingDriveawayController",
      };
    },
  ]);
})(window.angular);
